//import React from 'react'
//import '../css/about.css'
// function About() {
//   return (
//     <>
//     <div class="about">
//         <h1>About Us</h1>
//         <p style={{ fontWeight: 'bold'}}>
//           GeeksforGeeks is a leading platform...
//           </p>
//         <div class="about-info">
//             <div class="about-img">
//                 <img src="https://media.geeksforgeeks.org/wp-content/uploads/20230824153359/371ba38b-8a03-4bff-916c-c3fa5396ceda.jfif" alt="Geeksforgeeks" />
//             </div>
//             <div>
//             <p> GeeksforGeeks is a leading platform
//                 that provides computer science resources
//                 and coding challenges for programmers and
//                 technology enthusiasts,along with interview
//                 and exam preparations for upcoming aspirants.
//                 With a strong emphasis on enhancing coding skills
//                 and knowledge,it has become a trusted destination
//                 for over 12 million plus registered users worldwide.
//             </p>
//                 <button>Read More...</button>
//             </div>
//         </div>
//     </div>
 
 
// </>
//   )
// }

// export default About;
import React from 'react'
import '../css/bestproduct.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping, faE } from "@fortawesome/free-solid-svg-icons";
import {faEye} from "@fortawesome/free-solid-svg-icons"
import {faHeart} from "@fortawesome/free-solid-svg-icons"
import BestProduct from './BestProduct'
import '../css/bestsellers.css'

function About({ data }) {
  //  console.log('dATA', data)
  return (
      
     <div class="about">
        <h1>About Us</h1>
        <p style={{ fontWeight: 'bold'}}>
          GeeksforGeeks is a leading platform...
          </p>
        <div class="about-info">
            <div class="about-img">
                <img src="https://media.geeksforgeeks.org/wp-content/uploads/20230824153359/371ba38b-8a03-4bff-916c-c3fa5396ceda.jfif" alt="Geeksforgeeks" />
            </div>
            <div>
            <p> GeeksforGeeks is a leading platform
                that provides computer science resources
                and coding challenges for programmers and
                technology enthusiasts,along with interview
                and exam preparations for upcoming aspirants.
                With a strong emphasis on enhancing coding skills
                and knowledge,it has become a trusted destination
                for over 12 million plus registered users worldwide.
            </p>
                <button>Read More...</button>
            </div>
        </div>
    </div>
  
  )
}

export default About;